


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { SoftwareItem } from '@/types';
import ProductRow from '@/components/ProductCategory/ProductRow/ProductRow.vue';
import SoftwareDownloadButtons from '@/components/SoftwareDownloadButtons/SoftwareDownloadButtons.vue';
import EMotionIcon from '@/assets/icons/eMotion.svg';
import EMotion3Icon from '@/assets/icons/eMotion3.svg';
import Pix4dDesktopIcon from '@/assets/icons/pix4d-desktop.svg';
import Pix4dMobileIcon from '@/assets/icons/pix4d-mobile.svg';
import ParrotIcon from '@/assets/icons/parrot.svg';

@Component({
  components: {
    ProductRow,
    EMotionIcon,
    EMotion3Icon,
    Pix4dDesktopIcon,
    Pix4dMobileIcon,
    ParrotIcon,
    SoftwareDownloadButtons,
  },
})
export default class ProductRowSoftware extends Vue {
  @Prop({ required: true }) public item: SoftwareItem;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProductCategory/ProductRow/ProductRowSoftware.vue